/* @flow */
import Unread from 'entities/Unread';
import Collection from 'lib/Collection';

class Unreads extends Collection {
  initialize() {
    this.url = '/notifications/unread';
    this.model = Unread;
  }

  parse(response: Object): Object[] {
    if (response.unreads) {
      return response.unreads.concat(response['group_unreads'] || []);
    }
    return [];
  }
}

export default Unreads;



// WEBPACK FOOTER //
// ./src/collections/Unreads.js